import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthenticationInterceptor } from "./authentication.interceptor";
import { EndpointInterceptor } from "./endpoint.interceptor";
import { LoggingInterceptor } from "./logging.interceptor";
import { NetworkErrorInterceptor } from "./network-error.interceptor";
import { ServerSelectInterceptor } from "./server-select.interceptor";
import { TokenInjectInterceptor } from "./token-inject.interceptor";

export const InterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: ServerSelectInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: EndpointInterceptor, multi: true }, 
  { provide: HTTP_INTERCEPTORS, useClass: TokenInjectInterceptor,multi:true},
  { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi:true},
  { provide: HTTP_INTERCEPTORS, useClass: NetworkErrorInterceptor, multi: true },
]